<template>
    <div class="faq-section container mt-5">
        <h2 class="text-center mb-4 font-weight-bold">Frequently Asked Questions</h2>
        <div id="faqAccordion" class="accordion">
            <div class="card" v-for="(faq, index) in faqs" :key="index">
                <div class="card-header" :id="'heading' + index">
                    <h5 class="mb-0">
                        <button class="btn btn-link" type="button" data-toggle="collapse"
                            :data-target="'#collapse' + index" :aria-expanded="index === 0 ? 'true' : 'false'"
                            :aria-controls="'collapse' + index">
                            {{ faq.question }}
                        </button>
                    </h5>
                </div>
                <div :id="'collapse' + index" class="collapse" :class="{ show: index === 0 }"
                    :aria-labelledby="'heading' + index" data-parent="#faqAccordion">
                    <div class="card-body">
                        {{ faq.answer }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FAQSection",
    data() {
        return {
            faqs: [
                {
                    question: "What services do you offer?",
                    answer:
                        "We offer a wide range of services including tax filing (individual and business), retirement planning, investment strategies, payroll and employee benefits management, business consulting for growth and expansion, and financial planning. We aim to provide comprehensive solutions for both individuals and businesses."
                }, {
                    question: "Do you offer services for both individual and business tax filing?",
                    answer:
                        "Yes, we offer tax filing services for both individuals and businesses. Whether you're filing as an individual or need assistance with corporate tax returns, we can provide expert guidance and support to ensure compliance with tax laws.ˀ"
                }, {
                    question: "Can you help me with managing payroll or employee benefits?",
                    answer:
                        "Yes, we offer payroll management services that streamline payroll processing, ensuring accuracy and timely payments. We can also assist with managing employee benefits, including health insurance, retirement plans, and other perks that help attract and retain talent"
                }, {
                    question: "How can you support me with business growth or expansion?",
                    answer:
                        "We provide business consulting services to help you scale and grow. Whether it’s through financial strategy, tax planning, or operational improvements, we can offer tailored advice to optimize your business for growth. We can also help with market analysis, expansion strategies, and risk management."
                }, {
                    question: "How do you ensure transparency in billing and service costs?",
                    answer:
                        "We are committed to clear and transparent billing. Before any work begins, we provide a detailed breakdown of our fees and services so you know exactly what to expect. We avoid hidden charges and ensure that you are fully informed about the costs associated with our services throughout the process."
                },
            ]
        };
    }
};
</script>

<style scoped>
.btn-link {
    font-weight: 400;
    color: #28a745;
}

.faq-section {
    /* max-width: 800px;
    margin: 0 auto; */
}

.card-header button {
    text-decoration: none;
    font-weight: bold;
    font-size: 1.1rem;
}

.card-header button:focus {
    outline: none;
    box-shadow: none;
}
</style>